'use strict';

filterCategory.$inject = ["common", "Enums", "FilterCategoryItem", "gettextCatalog", "FilterHierarchyCategoryItem"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterCategory = filterCategory;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filterCategory(common, Enums, FilterCategoryItem, gettextCatalog, FilterHierarchyCategoryItem) {
    var clazz = function FilterCategory() {
        var defaults = {
            id: '',
            name: '',
            isHierarchical: false,
            isCollapsed: true,
            isLink: false,
            isSellerCategory: false,
            initialLimit: 15,
            limit: 15,
            items: [],
            order: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var filter = new clazz();

        var isSellerCategory = resource.context === Enums.categoryFilterType.sellerCategory.id;
        filter.limit = resource.initialAmountVisible;

        if (resource.context === Enums.categoryFilterType.category.id) {
            filter.id = String(resource.id);
            filter.name = resource.name;
        } else if (resource.context === Enums.categoryFilterType.sellerCategory.id) {
            filter.id = resource.id;
            filter.name = resource.name;
        } else if (resource.context === Enums.categoryFilterType.seller.id) {
            filter.id = Enums.otherCategoryType.seller.id;
            filter.limit = 9999;
            filter.name = gettextCatalog.getString('Seller');
        } else if (resource.context === Enums.categoryFilterType.discountType.id) {
            filter.id = Enums.otherCategoryType.discountType.id;
            filter.name = gettextCatalog.getString('Discount type');
        } else if (resource.context === Enums.categoryFilterType.customCategory.id) {
            filter.id = Enums.categoryFilterType.customCategory.id;
            filter.name = gettextCatalog.getString('Special Discounts');
        }

        filter.isCollapsed = false;
        filter.isHierarchical = resource.id === 2 || resource.hierarchyItems;
        filter.isLink = resource.isLink;
        filter.isSellerCategory = isSellerCategory;
        filter.initialLimit = resource.initialAmountVisible;
        filter.order = resource.order;

        var formatNameToPascalCase = resource.context === Enums.categoryFilterType.category.id && resource.id === Enums.categoryType.brand.id;
        filter.items = [];

        // check if there are hierarchyItems 
        if (resource.hierarchyItems) {
            resource.hierarchyItems.length > 0 ? filter.items = _lodash2.default.orderBy(resource.hierarchyItems, 'name') : null;
            filter.items = _lodash2.default.map(filter.items, function (item) {
                return FilterHierarchyCategoryItem.create(item, 0, formatNameToPascalCase);
            });
        }

        // if there are no hierarchyItems set the items
        if (filter.items.length === 0) {
            if (resource.items && resource.items.length > 0) {
                var orderedItems = [];
                if (resource.context === Enums.categoryFilterType.seller.id) {
                    orderedItems = _lodash2.default.orderBy(resource.items, ['isVIPSeller', 'name'], ['desc', 'asc']);
                } else {
                    orderedItems = _lodash2.default.orderBy(resource.items, 'name');
                }

                filter.items = _lodash2.default.map(orderedItems, function (item) {
                    return FilterCategoryItem.create(item, 0, formatNameToPascalCase);
                });
            }
        }

        return filter;
    };

    clazz.createShowDiscountsOnly = function () {
        var filter = new clazz();
        filter.id = Enums.otherCategoryType.discountsOnly.id;
        filter.name = gettextCatalog.getString('Discount');
        filter.isHierarchical = false;
        filter.isCollapsed = false;
        filter.isLink = false;
        filter.initialLimit = 15;
        filter.limit = 15;
        filter.items = [];
        filter.items.push(FilterCategoryItem.create({ id: 1, name: gettextCatalog.getString('Discounts only') }));
        return filter;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/filterCategoryModel.js
// module id = 749
// module chunks = 0